<template>
  <div class="mt-2 rounded-lg bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6">
    <div class="flex-1 flex justify-between sm:hidden">
      <a
        :href="getNavigationUrl(parseInt(page) - 1, parseInt(page) > 1)"
        class="inline-flex items-center px-4 py-2 border border-gray-300 text-sm leading-5 font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 focus:outline-none focus:ring-indigo-50 focus:border-indigo-300 active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150"
      >
        Previous
      </a>
      <a
        :href="getNavigationUrl(parseInt(page) + 1, true)"
        class="ml-3 inline-flex items-center px-4 py-2 border border-gray-300 text-sm leading-5 font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 focus:outline-none focus:ring-indigo-50 focus:border-indigo-300 active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150"
      >
        Next
      </a>
    </div>
    <div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
      <div>
        <p class="text-sm leading-5 text-gray-700">
          Showing
          <span class="font-medium">{{ startEntry }}</span>
          to
          <span class="font-medium">{{ endEntry }}</span>
          of
          <span class="font-medium">{{ total }}</span>
          results
        </p>
      </div>
      <div>
        <nav class="inline-flex shadow-sm">
          <a
            :href="getNavigationUrl(parseInt(page) - 1, parseInt(page) > 1)"
            class="inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:outline-none focus:border-indigo-300 focus:ring-indigo-50 active:bg-gray-100 active:text-gray-500 transition ease-in-out duration-150"
            :class="{ 'opacity-50 cursor-not-allowed pointer-events-none': parseInt(page) <= 1 }"
            aria-label="Previous"
          >
            <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
              <path
                fill-rule="evenodd"
                d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                clip-rule="evenodd"
              />
            </svg>
          </a>
          <a
            v-for="pageNumber of paginationToShow"
            :key="pageNumber"
            :href="getNavigationUrl(pageNumber + 1, true)"
            class="cursor-pointer -ml-px inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:border-indigo-300 focus:ring-indigo-50 active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150"
          >
            {{ pageNumber + 1 == page ? '...' : pageNumber + 1 }}
          </a>
          <a
            :href="getNavigationUrl(parseInt(page) + 1, hasNextPage)"
            class="-ml-px inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:outline-none focus:border-indigo-300 focus:ring-indigo-50 active:bg-gray-100 active:text-gray-500 transition ease-in-out duration-150"
            :class="{ 'opacity-50 cursor-not-allowed pointer-events-none': !hasNextPage }"
            aria-label="Next"
          >
            <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
              <path
                fill-rule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                clip-rule="evenodd"
              />
            </svg>
          </a>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    startEntry: {
      type: Number,
      required: true,
    },
    endEntry: {
      type: Number,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      page: this.$route.query.page ? this.$route.query.page : 1,
    };
  },
  computed: {
    numberOfPages() {
      return Math.ceil(this.total / 10);
    },
    paginationToShow() {
      let test = [];
      let page = parseInt(this.page);
      for (let i = 0; i < this.numberOfPages; i++) {
        test.push(i);
      }
      let start = page - 4 <= 0 ? 0 : page - 4;
      let end = page + 3;
      return test.slice(start, end);
    },
    hasNextPage() {
      return parseInt(this.page) < this.numberOfPages;
    },
  },
  mounted() {
    this.paginationToShow;
  },
  methods: {
    getNavigationUrl(pageNumber, isEnabled) {
      if (!isEnabled) {
        return false;
      }

      const baseUrl = this.$route.fullPath.replace(/page.*$/i, '');
      const separator = Object.keys(this.$route.query).length > 0 ? '&' : '?';
      return `${baseUrl}${separator}page=${pageNumber}`;
    },
  },
};
</script>
